var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ApproveTags disp-ib"},[_c('el-tag',{attrs:{"effect":"dark","type":_vm.statusEnum.colors[_vm.statusUse]}},[_vm._v("\n        "+_vm._s(_vm.statusEnum[_vm.isStockIn?'dictIn' : 'dictOut'][_vm.statusUse])+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }